<template>
  <generic-modal
    :height="duplicateAddressPopup.height"
    :width="duplicateAddressPopup.width"
    :modalClass="'full-screen-popup lg-screen-centered my-address-modal-container'"
    :contentScroll="false"
    :background="'transparent'"
    :backgroundBody="'white'"
    :animationStyle="'slide-up-stick-bottom'"
    v-if="showPopup"
    @close="closeDuplicateAddressPopup($event, '')"
  >
    <template v-slot:header>
      <div>
        <img
          :src="staticImgBaseUrl + '/images/global/handle-bg.svg'"
          class="handle-bg"
        /></div
    ></template>
    <template v-slot:body>
      <div>
        <div class="flex-column ptb16">
          <div class="fs-18 fw-700 pb12 plr16">{{ title }}</div>
          <div class="fs-14 color-slaty border-top pt16 plr16">
            {{ getSubTitle }}
          </div>
          <div class="plr16">
            <button
              class="btn bold secondary mt20 fw-700 width100"
              @click="selectDuplicateAddress()"
              v-if="getPrimaryCTAText"
            >
              {{ getPrimaryCTAText }}
            </button>
            <button
              class="btn bold primary mt12 fw-700 width100"
              @click="closeDuplicateAddressPopup()"
              v-if="secondaryCTAText"
            >
              {{ secondaryCTAText }}
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer> </template>
  </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";

export default {
  name: "DuplicateAddressPopup",
  components: {
    GenericModal,
  },
  props: [
    "title",
    "subtitle",
    "primaryCTAText",
    "secondaryCTAText",
    "duplicateAddress",
  ],
  data() {
    return {
      duplicateAddressPopup: {
        height: "100vh",
        width: "100%",
      },
      modulePropsData: {},
      staticImgBaseUrl,
      showPopup: true,
      clientPlatform,
    };
  },
  mounted() {},
  methods: {
    closeDuplicateAddressPopup() {
      this.showPopup = false;
    },
    selectDuplicateAddress() {
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
        this.duplicateAddress
      );
      LocalStorageFunc.setLocalStorageValue(
        "selectedAddress",
        this.duplicateAddress
      );
      let pos = {
        lat: this.duplicateAddress.latitude,
        lng: this.duplicateAddress.longitude,
      };
      let position = {
        coords: {
          latitude: pos.lat,
          longitude: pos.lng,
        },
        redirectTo: Utility.isRedirectedFromUrl("/cart-unified")
          ? Utility.sendToCartScreen
          : Utility.sendToHomepageScreen,
        homePageAddress: {
          topAddress: this.duplicateAddress.customer_address_name,
          bottomAddress: this.duplicateAddress.formatted_address,
        },
      };
      LocalStorageFunc.setToastNotifications({
        msg: "Address changed successfully!",
      });
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
      this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);
    },
  },
  computed: {
    getSubTitle() {
      return this.subtitle?.replace(
        "<AddressName>",
        this.duplicateAddress?.customer_address_name
      );
    },
    getPrimaryCTAText() {
      return this.primaryCTAText?.replace(
        "<AddressName>",
        this.duplicateAddress?.customer_address_name
      );
    },
  },
};
</script>
